<template>
  <v-select
    v-model="newValue"
    :items="field.items"
    :label="field.label"
    :menu-props="{ light: true}"
    placeholder=" "
    multiple
    clearable
    :disabled="false"
  />
</template>
<script>
export default {
  name: 'Newsletters',
  props: ['field', 'value'],
  data: function () {
    return { newValue: this.activeNewsletters(this.$props.value || {}) };
  },
  watch: {
    newValue (val) {
      val = this.newslettersInput(val);
      this.$emit('input', val);
    }
  },
  methods: {
    activeNewsletters (newsletters) {
      const activeNewsletters = [];
      // Remove schema property
      delete newsletters.__typename;
      Object.entries(newsletters).forEach(([newsletter, status]) => {
        // If newsletter is active
        if (status) {
          activeNewsletters.push(newsletter);
        }
      });
      return activeNewsletters;
    },
    newslettersInput (activeNewsletters) {
      const newsletters = {};
      this.field.items.forEach(option => {
        if (activeNewsletters.includes(option.value)) {
          newsletters[option.value] = true;
        } else {
          newsletters[option.value] = false;
        }
      });
      return newsletters;
    }
  }
};
</script>
